import { CustomValidators } from "./../../directives/custom-validator.directive";
import {
  AfterViewInit,
  Component,
  OnInit,
  ViewChild,
  NgZone,
  ElementRef,
  VERSION,
  Inject,
  Input,
  HostListener,
  EventEmitter,
  Output
} from "@angular/core";
import {
  FormControl,
  FormGroup,
  ControlValueAccessor,
  NG_VALUE_ACCESSOR,
  FormBuilder,
  NG_VALIDATORS,
  Validators,
  Validator,
  NgForm
} from "@angular/forms";
import { logbaseService } from "../../services/logbase.service";
import { HttpClient, HttpResponse } from "@angular/common/http";
import { dataService } from "../../services/data.service";
import {
  NgbModal,
  NgbActiveModal,
  ModalDismissReasons,
  NgbModalRef
} from "@ng-bootstrap/ng-bootstrap";
import { Router, ActivatedRoute } from "@angular/router";
import { formDialogService } from "../../services/formDialogService";
import { Observable ,  Subject } from "rxjs";
//import { NgxPermissionsService } from "ngx-permissions";
import { ToastrService } from "ngx-toastr";
import { TranslateService } from "@ngx-translate/core";
import { DataTableDirective } from "angular-datatables";
import { NgxSpinnerService } from "ngx-spinner";
import { environment } from "../../../environments/environment";


@Component({
  selector: "app-part-info",
  templateUrl: "./part-info.component.html",
  styleUrls: ["./part-info.component.scss"]
})
export class PartInfoComponent implements OnInit {
  saas_token=environment.excel_upload_saas
  vsLastName: any;
  vsFirstName: any;
  plantName: any;
  partDataFor: any;
  copiedPartInfo: any;
  suppCodeList: any;
  suppCodeVal: any;
  revisionList: any = [];
  appClosedList: any;
  approvedList: any;
  partStatusList: any;
  suppCode: any;
  pkgselect: any;
  packageLookup: any;
  disableSubmit: boolean;
  chosenFiles: any;
  imgToDelete: any;
  partImageDetails: any;
  imageInfos: any[] = [];
  displayOverallStatus: string;
  overAllPackageIDStatus: any;
  packageOverallStatus: any;
  navigateAfterSave: boolean = true;
  userRoleName: any;
  loginId: any;
  ProductionStatusEdit: boolean;
  partLSData: any;
  partsClassificationEdit: boolean;
  changeDateEdit: boolean;
  partHeightEdit: boolean;
  partLengthEdit: boolean;
  partWidthEdit: boolean;
  partMaterialEdit: boolean;
  partWeightEdit: boolean;
  userRoleId: any;
  partInfoWarn:boolean;

  disableDelete: boolean; 

  @Input()
  partInfoData: string;

  partInfo: any = null;
  splitCreatedDate: any;
  splitChangeDate: any;
  partInfoForm: FormGroup;
  partClassificationOpt: string[] = ["Non-Dangerous(通常品)", "Dangerous(危険品)"];
  seriesPartOpt: string[] = ["Series Part(生産部品)", "Development Part(試作部品)"];
  deliveryTimeOpt: string[] = [
    "08:00 - 10:00",
    "10:00 - 12:00",
    "12:00 - 15:00",
    "15:00 - 17:00",
    "20: 00-22: 00",
    "22: 00-24: 00"
  ];
  deliverypointOpt: string[] = ["TCK", "LDT"];
  buildingNumberOpt: any[] = [
    "#106=第８機械工場",
    "#107=第９機械工場",
    "#110=第２機械工場",
    "#111=第１組立工場",
    "#113=第５機械工場",
    "#139=EOL工場",
    "#141=第1シャシ組立工場",
    "#142=第2シャシ組立工場",
    "#143=第3シャシ組立工場",
    "#144=第2EOL工場",
    "#310=ＫＤ倉庫",
    "#312=第２倉庫",
    "#324=南門ＫＤ倉庫"
  ];

  partApiData: any;
  partData: any;
  parts: any;
  routePackageID: any;
  partInfoResult: any;
  partsInfoData: any;

  imagesFiles: any[] = [];
  uploadedFiles: any[] = [];
  modelRef: NgbModalRef;
  closeResult: string;

  @ViewChild(DataTableDirective)
  datatableElement: DataTableDirective;

  dtOptions: DataTables.Settings = {};
  dtTrigger: Subject<any> = new Subject();
  isDuplicationFilename;
  packageID: string;

  constructor(
    private form: FormBuilder,
    private logbaseService: logbaseService,
    private http: HttpClient,
    private dataService: dataService,
    private modalService: NgbModal,
    private route: ActivatedRoute,
    private router: Router,
    private formDialogService: formDialogService,
    private toastr: ToastrService,
    //private permissionsService: NgxPermissionsService,
    private translate: TranslateService,
    private spinner: NgxSpinnerService
  ) { 
    
  }

  ngOnInit() {
    this.spinner.show();
    // Get package id to get all other details
    this.routePackageID = this.route.snapshot.params["id"];
    localStorage.setItem("packageID", this.routePackageID);

    //this.lockPackage(this.routePackageID);

    this.logbaseService
      .getNewPartsbyPkgId(this.routePackageID)
      .subscribe(result => {
        this.spinner.show();
        //Get parts data from URL and bind in form fields
        this.partData = result.response;

        // Get Parts Information form data which is already saved
        this.getPartInfoById(this.partData);

        this.overAllPackageIDStatus = result.response.ovarAllPackageIDStatus;
        localStorage.setItem(
          "overAllPackageIDStatus",
          this.overAllPackageIDStatus
        );

        // to disable save, next & submit button if user already preformed their corresponding actions
        this.disableCheck(this.partData);
        // To get plant name
        this.getPlantName(this.partData);
        // To get vendor details
        this.vsdetails(this.partData);

        if (this.overAllPackageIDStatus == "new") {
          this.displayOverallStatus = "New";
        } else if (this.overAllPackageIDStatus == "inProgress") {
          this.displayOverallStatus = "In Progress";
        } else if (this.overAllPackageIDStatus == "approved") {
          this.displayOverallStatus = "Approved";
          this.partInfoForm.disable();
          this.disableSubmit = true;
        } else if (this.overAllPackageIDStatus == "rejected") {
          this.displayOverallStatus = "Rejected";
        } else if (this.overAllPackageIDStatus == "underReview") {
          this.displayOverallStatus = "Under Review";
        } else if (this.overAllPackageIDStatus == "approvedAndClosed") {
          this.displayOverallStatus = "Approved & Closed";
          this.partInfoForm.disable();
          this.disableSubmit = true;
        }
      });

    // Get user role based on user login stored in local storage
    let userDetails = localStorage.getItem("userDetails");
    let userDetJson = JSON.parse(userDetails);
    this.userRoleId = userDetJson.userRoleMappings[0].roleId;
    this.userRoleName = userDetJson.userRoleMappings[0].roleName;
    this.loginId = userDetJson.loginId;

    this.createFormControls();
    this.checkFieldAccess();
    //this.disableFields();
    this.sendFormData();

    this.suppCodeVal = userDetJson.supplierCode ? userDetJson.supplierCode.toString() : '';

  
    // To show supplier codes in supplier dropdown list for SM, log, operation
    this.suppCodeList = this.suppCodeVal.split(",");

    this.suppCode = this.suppCodeList[0];

    var appPartStatusList: any, appRevisionList = [], urPartStatusList: any, underReviewList = [], underReviewRevisionList = [];

    var dataToSend = {
      lineNumbers: [],
      pageNum: 0,
      partStatus: "approved",
      roleId: this.userRoleId,
      searchValue: "",
      size: 50,
      sortColumn: "",
      sortType: "",
      supplierCodes: this.suppCodeList
    };

    var urdataToSend = {
      lineNumbers: [],
      pageNum: 0,
      partStatus: "underReview",
      roleId: this.userRoleId,
      searchValue: "",
      size: 50,
      sortColumn: "",
      sortType: "",
      supplierCodes: this.suppCodeList
    };

    this.logbaseService
      .getPartStatusList(dataToSend)
      .subscribe(result => {
        appPartStatusList = result;
        if (appPartStatusList != null) {
          this.approvedList = appPartStatusList.response.content;
          //this.appClosedList = this.partStatusList.response.approvedAndClosed;
        }

        for (let item of this.approvedList) {
          appRevisionList.push(item);
        }

      });
    this.logbaseService
      .getPartStatusList(urdataToSend)
      .subscribe(result => {
        urPartStatusList = result;
        if (urPartStatusList != null) {
          underReviewList = urPartStatusList.response.content;
          //this.appClosedList = this.partStatusList.response.approvedAndClosed;
        }

        for (let item of underReviewList) {
          appRevisionList.push(item);
        }

      });

    this.revisionList = appRevisionList;

    

  }

  // lockPackage(routePackageID) {
  //   let dataToSend = {
  //     pkgStatus: "DISABLE",
  //     pkgId: routePackageID
  //   }
  //   this.logbaseService.packageLockUnlock(dataToSend).subscribe(result => {
  //   });
  // }

  // @HostListener("window:beforeunload", ["$event"])
  // public beforeunloadHandler($event) {
  //   $event.returnValue = "Are you sure?";
  //   this.packageID = localStorage.getItem('packageID')
  //   if (confirm("Are you sure you want to leave this page?")) {
  //     return true;
  //   } else {
  //     this.lockUnlockPackage(this.packageID);
  //     return false;
  //   }
  // }

  // lockUnlockPackage(packageID) {
  //   let dataToSend = {
  //     pkgStatus: "ENABLE",
  //     pkgId: packageID
  //   }
  //   this.logbaseService.packageLockUnlock(dataToSend).subscribe(result => {
  //   });
  // }

  disableCheck(partData) {

    // Get user role based on user login stored in local storage
    let userDetails = localStorage.getItem("userDetails");
    let userDetJson = JSON.parse(userDetails);
    let loggedinSuppCode = userDetJson.supplierCode;
    let loggedinLineNo = userDetJson.lineNumbers;
    let loggedInopMgrSupplierCode=userDetJson.operationManagerSupplierCode;
    let loggedInopMgrDeliveryPoint=userDetJson.operationManagerdeliveryPointMaster;

    if (this.userRoleId == 4) {
      if (loggedinLineNo != null) {
        var findLineNo = loggedinLineNo.find(x => x == this.partData.lineNumber);
        var findOMSupCode=loggedInopMgrSupplierCode.find(x=>x==this.partData.supplierCode);
        var findOMDelPoint=loggedInopMgrDeliveryPoint.find(x=>x==this.partData.deliveryPoint);
      }
      findSuppCode = '';
    } else {
      if (loggedinSuppCode != null) {
        var findSuppCode = loggedinSuppCode.find(x => x == this.partData.supplierCode);
      }
      findLineNo = '';
    }

    if (findSuppCode == undefined) {
      this.partInfoForm.disable();
      this.disableSubmit = true;
    } else if (findLineNo == undefined && findOMDelPoint==undefined) {
      this.partInfoForm.disable();
      this.disableSubmit = true;
    } else {

      if (this.userRoleId == 5) {
        this.partInfoForm.disable();
        //  if (this.overAllPackageIDStatus == 'approvedAndClosed' || this.overAllPackageIDStatus == 'rejectedAndClosed' || this.overAllPackageIDStatus == 'underReview') {
        this.disableSubmit = true;
        // }
      }
      if (this.userRoleId == 1) {
        if (
          this.overAllPackageIDStatus == "approvedAndClosed" ||
          this.overAllPackageIDStatus == "rejectedAndClosed" ||
          this.overAllPackageIDStatus == "underReview"
        ) {
          this.disableSubmit = true;
        }
      } else if (this.userRoleId == 2) {
        if (
          this.overAllPackageIDStatus == "new" ||
          this.overAllPackageIDStatus == "inProgress" ||
          this.overAllPackageIDStatus != "underReview" ||
          (this.overAllPackageIDStatus == "underReview" &&
            (partData.supplierManagerStatus == "approved" ||
              partData.supplierManagerStatus == "rejected"))
        ) {
          this.disableSubmit = true;
        }
      } else if (this.userRoleId == 3) {
        if (
          this.overAllPackageIDStatus == "new" ||
          this.overAllPackageIDStatus == "inProgress" ||
          this.overAllPackageIDStatus != "underReview" ||
          (this.overAllPackageIDStatus == "underReview" &&
            (partData.logisticStatus == "approved" ||
              partData.logisticStatus == "rejected"))
        ) {
          this.disableSubmit = true;
        }
      } else if (this.userRoleId == 4) {
        if (
          this.overAllPackageIDStatus == "new" ||
          this.overAllPackageIDStatus == "inProgress" ||
          this.overAllPackageIDStatus != "underReview" ||
          (this.overAllPackageIDStatus == "underReview" &&
            (partData.operatorStatus == "approved" ||
              partData.operatorStatus == "rejected"))
        ) {
          this.disableSubmit = true;
        }
      } else if (this.userRoleId == 7) {
        if (
          this.overAllPackageIDStatus == "new" ||
          this.overAllPackageIDStatus == "inProgress" ||
          this.overAllPackageIDStatus != "underReview" ||
          (this.overAllPackageIDStatus == "underReview" &&
            (partData.supplierManagerVSStatus == "approved" ||
              partData.supplierManagerVSStatus == "rejected"))
        ) {
          this.disableSubmit = true;
        }
      } else if (this.userRoleId == 9) {
        if (
          this.overAllPackageIDStatus == "approved" ||
          this.overAllPackageIDStatus == "rejected") {
          this.disableSubmit = true;
        }
      }
    }
  }

  getPlantName(partData) {
    let delPoint = partData.deliveryPoint;
    this.logbaseService.fetchPlantName(delPoint).subscribe(result => {
      this.plantName = result.response.plantName;
      this.partInfoForm.patchValue({
        plantName: result.response.plantName
      });
    });
  }

  vsdetails(partData) {
    let vscode = partData.vendorSchedulerCode;
    this.logbaseService.fetchvsdetails(vscode).subscribe(result => {
      this.vsFirstName = result.response.vendorSchedulerFirstNameEN;
      this.vsLastName = result.response.vendorSchedulerLastNameEN;

      this.partInfoForm.patchValue({
        vsLastName: result.response.vendorSchedulerFirstNameEN,
        vsFirstName: result.response.vendorSchedulerLastNameEN
      });
    });
    this.route.queryParams.subscribe(params => {
      if (params['validate'] === 'true') {
        this.savePartForm();
        console.log("test")
        this.router.navigate(['partDetails/packageInfo',this.routePackageID])
      }
    });

  }

  checkFieldAccess() {
    if (this.userRoleId == 1) {
      this.partWeightEdit = false;
      this.partMaterialEdit = false;
      this.partWidthEdit = false;
      this.partLengthEdit = false;
      this.partHeightEdit = false;
      this.changeDateEdit = true;
      this.partsClassificationEdit = false;
      this.ProductionStatusEdit = false;
      //this.disableFields();
    } else if (this.userRoleId == 2 || this.userRoleId == 7) {
      this.partWeightEdit = true;
      this.partMaterialEdit = true;
      this.partWidthEdit = true;
      this.partLengthEdit = true;
      this.partHeightEdit = true;
      this.changeDateEdit = false;
      this.partsClassificationEdit = false;
      this.ProductionStatusEdit = false;
    } else if (this.userRoleId == 3) {
      this.partWeightEdit = true;
      this.partMaterialEdit = true;
      this.partWidthEdit = true;
      this.partLengthEdit = true;
      this.partHeightEdit = true;
      this.changeDateEdit = true;
      this.partsClassificationEdit = false;
      this.ProductionStatusEdit = false;
    } else if (this.userRoleId == 4) {
      this.partWeightEdit = true;
      this.partMaterialEdit = true;
      this.partWidthEdit = true;
      this.partLengthEdit = true;
      this.partHeightEdit = true;
      this.changeDateEdit = true;
      this.partsClassificationEdit = false;
      this.ProductionStatusEdit = true;
      //this.disableFields();
    }
  }

  // disableFields() {
  //   let currentStatus = localStorage.getItem("overAllPackageIDStatus");
  //   if (currentStatus == 'approvedAndClosed' || currentStatus == 'approved') {
  //     this.partInfoForm.disable();
  //   }
  // };

  getPartInfoById(partData) {
    this.spinner.show();
    let localPartData = localStorage.getItem("copiedPart");
    if (localPartData) {
      if (localPartData != "undefined") {
        let copiedPart = JSON.parse(localPartData);
        if (copiedPart.currentPart == this.routePackageID) {
          if (copiedPart.partInfoSave == 1) {
            this.partDataFor = this.routePackageID;
          } else {
            this.partDataFor = copiedPart.copyPart;
          }
        } else {
          this.partDataFor = this.routePackageID;
        }
      } else {
        this.partDataFor = this.routePackageID;
      }
    } else {
      this.partDataFor = this.routePackageID;
    }

    this.logbaseService.getPartInfoData(this.partDataFor).subscribe(result => {
      this.spinner.hide();
      this.partInfoResult = result;

      this.partImageDetails = this.partInfoResult.response.imageInfos;

      this.partInfoForm.patchValue({
        partNumber: partData.partNumber,
        partName: partData.partName,
        partWeight: this.partInfoResult.response.partWeight,
        partMaterial: this.partInfoResult.response.partMaterial,
        partClassification: this.partInfoResult.response.partClassification,
        ProductionStatus: this.partInfoResult.response.productionStatus,
        predecessorNumber: this.partInfoResult.response.predecessorNumber,
        vsCode: partData.vendorSchedulerCode,
        // vsLastName: partData.vendorSchedulerLastName,
        // vsFirstName: partData.vendorSchedulerFirstName,
        dimensionWidth: this.partInfoResult.response.dimensionWidth,
        dimensionLength: this.partInfoResult.response.dimensionLength,
        dimensionHeight: this.partInfoResult.response.dimensionHeight,
        // plantName: this.partInfoResult.response.plantName,
        deliveryTimeWindow: partData.deliveryTimeWindow,
        deliveryPoint: partData.deliveryPoint,
        lineNumber: partData.lineNumber,
        supplyProcessCode: partData.supplierCode
      });
      
    });
    
  }

  createFormControls() {
    this.partInfoForm = new FormGroup({
      partNumber: new FormControl({ value: "", disabled: true }),
      partName: new FormControl({ value: "", disabled: true }),
      partWeight: new FormControl(
        { value: "", disabled: this.partWeightEdit },
        [Validators.required, CustomValidators.isNum]
      ),
      partMaterial: new FormControl({
        value: "",
        disabled: this.partMaterialEdit
      }),
      partClassification: new FormControl(
        { value: "", disabled: this.partsClassificationEdit },
        Validators.required
      ),
      ProductionStatus: new FormControl(
        { value: "", disabled: this.ProductionStatusEdit },
        Validators.required
      ),
      predecessorNumber: new FormControl({ value: "", disabled: false }),
      vsCode: new FormControl({ value: "", disabled: true }),
      vsLastName: new FormControl({ value: "", disabled: true }, [
        Validators.required,
        Validators.maxLength(20)
      ]),
      vsFirstName: new FormControl({ value: "", disabled: true }, [
        Validators.required,
        Validators.maxLength(20)
      ]),
      dimensionWidth: new FormControl(
        { value: "", disabled: this.partWidthEdit },
        [Validators.required, Validators.maxLength(6), CustomValidators.isNum]
      ),
      dimensionLength: new FormControl(
        { value: "", disabled: this.partLengthEdit },
        [Validators.required, Validators.maxLength(6), CustomValidators.isNum]
      ),
      dimensionHeight: new FormControl(
        { value: "", disabled: this.partHeightEdit },
        [Validators.required, Validators.maxLength(6), CustomValidators.isNum]
      ),
      plantName: new FormControl({ value: "", disabled: true }),
      deliveryTimeWindow: new FormControl({ value: "", disabled: true }),
      deliveryPoint: new FormControl({ value: "", disabled: true }),
      lineNumber: new FormControl({ value: "", disabled: true })
      // buildingNumber: new FormControl( '',Validators.required),
      // lineCode: new FormControl('',Validators.required),
      // groupNumber: new FormControl('',Validators.required),
      // processName:new FormControl('',[Validators.required]),
      // rackNumber: new FormControl( '',[Validators.required]),
      // layer: new FormControl('',[Validators.required])
    });
  }

  getImgUri(imgUri: String){
    if(imgUri.includes("https://a9ndevjpeastlbs01.blob.core.windows.net") || imgUri.includes("https://a9nprodjpeastlbs01.blob.core.windows.net")){
      return imgUri+this.saas_token;
    }
    else if(imgUri!=null) {
      this.disableDelete=true;
      return "https://a9ndevjpeastlbs01.blob.core.windows.net/images/Unauthorized.JPG";
    }

  }
  savePartForm() {
    if (this.partInfoForm.invalid) {
      this.partInfoForm.markAllAsTouched();
      this.spinner.hide();
      this.translate.get("PARTFORMINCOMPLETE").subscribe((res: string) => {
        this.toastr.error(res || "Part Information Form is incomplete");
      });
      return;
    }

    this.spinner.show();
    let imagesUp = [];
    if (this.partImageDetails) {
      this.partImageDetails.forEach(function (value, key) {
        imagesUp.push({
          imageId: value.imageId,
          imageName: value.imageName,
          imageUri: !value.imageUri?.includes("Unauthorized") ? value.imageUri : null,
          isMasterDataSheet: null
        });
      });
    }

    let formDataToSend = {
      packageId: this.partData.packageId,
      plantName: this.partInfoForm.get("plantName").value,
      productionStatus: this.partInfoForm.get("ProductionStatus").value,
      partWeight: this.partInfoForm.get("partWeight").value,
      partClassification: this.partInfoForm.get("partClassification").value,
      partMaterial: this.partInfoForm.get("partMaterial").value,
      predecessorNumber: this.partInfoForm.get("predecessorNumber").value,
      ProductionStatus: this.partInfoForm.get("ProductionStatus").value,
      deliveryTimeWindow: this.partInfoForm.get("deliveryTimeWindow").value,
      // supplyProcessCode: this.partInfoForm.get('supplyProcessCode').value,
      dimensionWidth: this.partInfoForm.get("dimensionWidth").value,
      dimensionHeight: this.partInfoForm.get("dimensionHeight").value,
      dimensionLength: this.partInfoForm.get("dimensionLength").value,
      changedBy: this.partData.supplierCode,
      imageInfos: imagesUp
    };

    this.logbaseService.setFormData(formDataToSend);
    console.log("data is",formDataToSend)


    this.logbaseService.savePartFormData(formDataToSend).subscribe(response => {
      // Success
      this.spinner.hide();
      this.translate.get("PARTFORMSUCCESSMSG").subscribe((res: string) => {
        let localPartData = localStorage.getItem("copiedPart");
        if (localPartData != "undefined") {
          let copiedPart = JSON.parse(localPartData);

          let pkgSelectPid;
          if (this.pkgselect != null || this.pkgselect != undefined) {
            pkgSelectPid = this.pkgselect.packageId;
          } else {
            pkgSelectPid = this.routePackageID;
          }

          // Data copy set to 1 if part info saved
          if (copiedPart != null) {
            this.copiedPartInfo = {
              currentPart: this.routePackageID,
              copyPart: pkgSelectPid,
              partInfoSave: 1,
              supplyInfoSave: 0,
              pkgInfoSave: 0
            };
          }
        }
        localStorage.setItem("copiedPart", JSON.stringify(this.copiedPartInfo));

        this.toastr.success(res);
      });
      // this.toastr.success('Part Information Form Saved Successfully!');
      // Call API to get data once after part info form saved
      this.getPartInfoById(this.partData);
    });

    // Update status of package from new to inProgress status only by supplier
    if (this.overAllPackageIDStatus != "inProgress") {
      if (this.userRoleId == 1 || this.userRoleId == 9) {
        let statusDataToSend = {
          packStatus: "inProgress",
          packageid: this.partData.packageId,
          updatedBy: this.loginId,
          userRole: this.userRoleId
        };

        this.logbaseService
          .updatePackageStatus(statusDataToSend)
          .subscribe(response => {
            this.logbaseService
              .getNewPartsbyPkgId(this.routePackageID)
              .subscribe(result => {
                this.overAllPackageIDStatus =
                  result.response.ovarAllPackageIDStatus;
                if (this.overAllPackageIDStatus == "new") {
                  this.displayOverallStatus = "New";
                } else if (this.overAllPackageIDStatus == "inProgress") {
                  this.displayOverallStatus = "In Progress";
                } else if (this.overAllPackageIDStatus == "approved") {
                  this.displayOverallStatus = "Approved";
                } else if (this.overAllPackageIDStatus == "rejected") {
                  this.displayOverallStatus = "Rejected";
                }
              });
          });
      }
    }
    this.navigateAfterSave = false;
  }

  saveNextPartInfo() {
    if (this.partInfoForm.invalid) {
      this.partInfoForm.markAllAsTouched();
      this.translate.get("PARTFORMINCOMPLETE").subscribe((res: string) => {
        this.toastr.error(res || "Part Information Form is incomplete");
      });
      return;
    }
    this.savePartForm();
    setTimeout(() => {
      this.router.navigate(["/partDetails/supplyInfo/" + this.routePackageID]);
    }, 200);
  }

  //Open History Modal
  openHistoryModal(content) {
    this.modalService.open(content);
  }

  canDeactivate() {
    if(this.partInfoWarn)
    this.saveNextPartInfo();
    if (this.partInfoForm.dirty && this.navigateAfterSave == true) {
      return this.formDialogService.confirm();
    }
    return true;
  }

  sendFormData(): void {
    // send message to subscribers via observable subject
    this.dataService.sendFormData(this.partInfoForm);
  }

  uploadPartImg(event, form) {
    this.isDuplicationFilename = false
    let imagesUp = [];
    const formdata = new FormData();
    let isUniqueFile
    if (this.partImageDetails) {
      this.partImageDetails.forEach(function (value, key) {
        for (let i = 0; i < event.files.length; i++) {
          if (event.files[i].name == value.imageName) {
            isUniqueFile = true;
            form.clear();
          } else {
            imagesUp.push({
              imageId: value.imageId,
              imageName: value.imageName,
              imageUri: value.imageUri && !value.imageUri.includes("Unauthorized") ? value.imageUri : null,
              isMasterDataSheet: null
            });
          };
        }
      });

    }
    this.isDuplicationFilename = isUniqueFile
    if (!this.isDuplicationFilename) {
      event.files.forEach(function (value, key) {
        //formdata.append('file', value);
        formdata.append("imageFiles", value);
        // Loop on image uploaded
        imagesUp.push({ imageName: value.name });
      });

      let formDataToSend = {
        packageId: this.partData.packageId,
        plantName: this.partInfoForm.get("plantName").value,
        productionStatus: this.partInfoForm.get("ProductionStatus").value,
        partWeight: this.partInfoForm.get("partWeight").value,
        partClassification: this.partInfoForm.get("partClassification").value,
        partMaterial: this.partInfoForm.get("partMaterial").value,
        predecessorNumber: this.partInfoForm.get("predecessorNumber").value,
        ProductionStatus: this.partInfoForm.get("ProductionStatus").value,
        deliveryTimeWindow: this.partInfoForm.get("deliveryTimeWindow").value,
        //supplyProcessCode: this.partInfoForm.get('supplyProcessCode').value,
        dimensionWidth: this.partInfoForm.get("dimensionWidth").value,
        dimensionHeight: this.partInfoForm.get("dimensionHeight").value,
        dimensionLength: this.partInfoForm.get("dimensionLength").value,
        changedBy: this.partData.supplierCode,
        imageInfos: imagesUp
      };

      this.logbaseService.savePartFormData(formDataToSend).subscribe(response => {
        // Success
        // Call API to get data once after part info form saved
        this.getPartInfoById(this.partData);
        this.logbaseService
          .partImgUpload(formdata, this.routePackageID)
          .subscribe(response => {
            this.translate.get("IMG_UPLOAD_SUCCESS").subscribe((res: string) => {
              this.toastr.success(res);
            });
            // Call API to get data once after part info form saved
            this.getPartInfoById(this.partData);
            form.clear();
          });
      });

      // Update status of package from new to inProgress status only by supplier
      if (this.overAllPackageIDStatus != "inProgress") {
        if (this.userRoleId == 1) {
          let statusDataToSend = {
            packStatus: "inProgress",
            packageid: this.partData.packageId,
            updatedBy: this.loginId,
            userRole: this.userRoleId
          };

          this.logbaseService
            .updatePackageStatus(statusDataToSend)
            .subscribe(response => {
              this.logbaseService
                .getNewPartsbyPkgId(this.routePackageID)
                .subscribe(result => {
                  this.overAllPackageIDStatus =
                    result.response.ovarAllPackageIDStatus;
                  if (this.overAllPackageIDStatus == "new") {
                    this.displayOverallStatus = "New";
                  } else if (this.overAllPackageIDStatus == "inProgress") {
                    this.displayOverallStatus = "In Progress";
                  } else if (this.overAllPackageIDStatus == "approved") {
                    this.displayOverallStatus = "Approved";
                  } else if (this.overAllPackageIDStatus == "rejected") {
                    this.displayOverallStatus = "Rejected";
                  }
                });
            });
        }
      }
      this.navigateAfterSave = false;

    }

    this.savePartForm();

  }

  openImgDelCfm(imgToDel, imgdelModal) {
    this.modelRef = this.modalService.open(imgdelModal, {backdrop:false});
    this.imgToDelete = imgToDel;
  }

  deletePartImg() {
    this.modelRef.close();
    let dataToSend = [
      {
        imageId: this.imgToDelete.imageId,
        imageName: this.imgToDelete.imageName,
        imageUri: this.imgToDelete.imageUri,
        imageTitle: this.imgToDelete.imageTitle,
        isMasterDataSheet: "false"
      }
    ];

    this.logbaseService
      .deletePartImage(dataToSend, this.routePackageID)
      .subscribe(result => {
        this.translate.get('deleted Successfully').subscribe((res: string) => {
          this.toastr.success('' + this.imgToDelete.imageName + ' ' + res);
        });
        // Call API to get data once after image deleted
        this.getPartInfoById(this.partData);
      });
  }

  openLookup(lookupModal) {
    localStorage.setItem('lookUp', 'yes');
    this.modelRef = this.modalService.open(lookupModal, {
      size: "lg",
      windowClass: "detail-modal",backdrop:false
    });
    this.partInfoWarn=true;
  }

  showLookupData() {
    this.modelRef.close();

    this.logbaseService
      .getPartInfoData(this.pkgselect.packageId)
      .subscribe(result => {
        this.partInfoResult = result;

        this.partImageDetails = this.partInfoResult.response.imageInfos;
        this.partInfoForm.patchValue({
          partWeight: this.partInfoResult.response.partWeight,
          partMaterial: this.partInfoResult.response.partMaterial,
          partClassification: this.partInfoResult.response.partClassification,
          ProductionStatus: this.partInfoResult.response.productionStatus,
          predecessorNumber: this.pkgselect.partNumber,
          dimensionWidth: this.partInfoResult.response.dimensionWidth,
          dimensionLength: this.partInfoResult.response.dimensionLength,
          dimensionHeight: this.partInfoResult.response.dimensionHeight,
          plantName: this.partInfoResult.response.plantName
        });
      });

    this.copiedPartInfo = {
      currentPart: this.routePackageID,
      copyPart: this.pkgselect.packageId,
      partInfoSave: 0,
      supplyInfoSave: 0,
      pkgInfoSave: 0
    };

    localStorage.setItem("copiedPart", JSON.stringify(this.copiedPartInfo));
  }
}
